/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";

import { NoteCell } from "./Notes";
import { NumberCell } from "./Number";

const formatCurrency = n => {
  if (n) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    }).format(n);
  }
  return "$0.00";
};

const formatNumber = n => {
  if (n) {
    return new Intl.NumberFormat("en-US").format(n);
  }
  return 0;
};
export const ORDER_DETAIL_BILLING_COLUMNS = [
  {
    Header: "Code",
    accessor: "Product.ProductCode",
    id: "ProductCode",
    Cell: ({ cell }) => <a>{cell.value}</a>
  },
  {
    Header: "Description",
    accessor: "Description",
    id: "Description"
  },
  {
    Header: "Category",
    accessor: "Product.ProductCategory.CodeDescription",
    id: "Product.ProductCategory.CodeDescription"
  },
  {
    Header: "Qty",
    accessor: "Quantity",
    id: "Quantity",
    Cell: ({ cell }) =>
      cell.value ? <NumberCell value={formatNumber(cell.value)} /> : ""
  },
  {
    Header: "UOM",
    accessor: "UnitOfMeasurement.CodeDescription",
    id: "UOM"
  },
  {
    Header: "Rate",
    accessor: "Rate",
    id: "Rate",
    Cell: ({ cell }) => <NumberCell value={cell.value} />
  },
  {
    Header: "%",
    accessor: "Percentage",
    id: "Percentage",
    Cell: ({ cell }) => <NumberCell value={`${cell.value}%`} />
  },
  {
    Header: "Ext",
    accessor: "Extension",
    id: "Extension",
    Cell: ({ cell }) => <NumberCell value={formatCurrency(cell.value)} />
  },
  {
    Header: "External Comment",
    accessor: "ExternalComm",
    id: "ExternalComments"
  },
  {
    Header: "Internal Comment",
    accessor: "InternalComm",
    id: "InternalComments"
  },
  {
    Header: "Note",
    accessor: "Note",
    id: "Note",
    Cell: NoteCell
  },
  {
    Header: "Override",
    accessor: "OverrideFlag",
    id: "OverrideFlag"
  },
  {
    Header: "Order",
    accessor: "Product.ListOrder",
    id: "Product.ListOrder",
    sortType: (rowA, rowB) => {
      const aVal = rowA.original.Product?.ListOrder || 9999;
      const bVal = rowB.original.Product?.ListOrder || 9999;
      if (aVal > bVal) return 1;
      if (bVal > aVal) return -1;
      return 0;
    }
  }
];

export const ORDER_DETAIL_DISPATCHER_COLUMNS = [
  {
    Header: "Product #",
    accessor: "Product.ProductCode",
    id: "ProductNumber"
  },
  {
    Header: "Description",
    accessor: "Description",
    id: "Description"
  },
  {
    Header: "Quantity",
    accessor: "Quantity",
    id: "Quantity"
  },
  {
    Header: "Hazmat Code",
    accessor: "Hazmat",
    id: "HazmatCode"
  }
];
